export default "__VITE_ASSET__CvHqq4Rk__"